var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnlargeAttachment(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.75a.75.75 0 00-1.5 0v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 000 1.5h2.5A2.25 2.25 0 008.5 6.25v-2.5zM8.5 20.25a.75.75 0 01-1.5 0v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 010-1.5h2.5a2.25 2.25 0 012.25 2.25v2.5zM16.25 3a.75.75 0 00-.75.75v2.5a2.25 2.25 0 002.25 2.25h2.5a.75.75 0 000-1.5h-2.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75zM15.5 20.25a.75.75 0 001.5 0v-2.5a.75.75 0 01.75-.75h2.5a.75.75 0 000-1.5h-2.5a2.25 2.25 0 00-2.25 2.25v2.5z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnlargeAttachment);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconEnlargeAttachment.853683d0.svg";
export { MemoForwardRef as ReactComponent };